"use client";
import * as React from "react";
import "./gamestyle.css";

export const TokenHighlights = () => {
  return (
    <section className="mt-44 w-full max-w-[1344px] px-4 mx-auto max-md:mt-10">
      <div className="group-21 relative">
        <div className="token-highlights">
          <div className="frame-38 flex max-md:flex-col items-center text-center gap-6">
            <header>
              <h1 className="font-fredoka text-6xl font-bold tracking-wider text-white leading-[72px] w-[629px] 
                max-md:w-full max-md:text-5xl max-md:leading-[56px] 
                max-sm:text-3xl max-sm:leading-10 max-sm:tracking-wide">
                <span>Baby Unicorn </span>
                <span className="bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300 bg-clip-text text-transparent">
                  Token Highlights
                </span>
              </h1>
            </header>

            <div className="frame-39">
              <p className="text-wrapper-20 text-lg text-white text-center max-md:text-base">
                Discover a token built for joy and safety! Baby Unicorn combines
                a family-friendly design, a fun-filled ecosystem of games and
                rewards, a strong community spirit, and transparent, secure
                technology
              </p>
            </div>
          </div>

          <div className="frame-47 flex flex-col lg:flex-row gap-12 mt-12">
            {/* Left Content */}
            <div className="flex flex-col gap-10 w-full lg:w-3/5">
              {/* Block 1 */}
              <div className="flex flex-col md:flex-row gap-6">
                {/* Family-Friendly */}
                <div className="frame-50 flex-1 text-center md:text-left">
                  <div className="icon-instance-node mb-4 mx-auto md:mx-0 flex justify-center md:justify-start">
                    <img
                      src="/Family-Friend.svg"
                      alt="Family Friendly Icon"
                      width={64}
                      height={64}
                    />
                  </div>
                  <div className="text-wrapper-27 text-xl font-semibold">
                    Family-Friendly
                  </div>
                  <p className="div-3 text-sm text-gray-300">
                    Safe, easy-to-use, and perfect for newcomers
                  </p>
                </div>

                {/* Fun Ecosystem */}
                <div className="frame-51 flex-1 text-center md:text-left">
                  <div className="icon-instance-node mb-4 mx-auto md:mx-0">
                    <img
                      src="/Fun-ecosystem.svg"
                      alt="Fun Ecosystem Icon"
                      width={64}
                      height={64}
                    />
                  </div>
                  <div className="text-wrapper-27 text-xl font-semibold">
                    Fun Ecosystem
                  </div>
                  <p className="div-3 text-sm text-gray-300">
                    Games, collectibles, rewards, and learning tools
                  </p>
                </div>
              </div>

              {/* Block 2 */}
              <div className="flex flex-col md:flex-row gap-6">
                {/* Community-Driven */}
                <div className="frame-50 flex-1 text-center md:text-left">
                  <div className="icon-instance-node mb-4 mx-auto md:mx-0">
                    <img
                      src="/community-driven.svg"
                      alt="Community Driven Icon"
                      width={64}
                      height={64}
                    />
                  </div>
                  <div className="text-wrapper-27 text-xl font-semibold">
                    Community-Driven
                  </div>
                  <p className="div-3 text-sm text-gray-300">
                    Shaped by a positive, inclusive community
                  </p>
                </div>

                {/* Secure & Transparent */}
                <div className="frame-50 flex-1 text-center md:text-left">
                  <div className="icon-instance-node mb-4 mx-auto md:mx-0">
                    <img
                      src="sequre-transparent.svg"
                      alt="Secure & Transparent Icon"
                      width={64}
                      height={64}
                    />
                  </div>
                  <div className="text-wrapper-27 text-xl font-semibold">
                    Secure & Transparent
                  </div>
                  <p className="div-3 text-sm text-gray-300">
                    Fully audited smart contracts
                  </p>
                </div>
              </div>
            </div>

            {/* Right Content: Image */}
            <div className="img-wrapper w-full lg:w-2/5 flex justify-center items-center">
              <img
                className="group-23 w-full max-w-[400px] h-auto object-contain"
                alt="Group"
                src="https://c.animaapp.com/mc7ogb7a9X7XEN/img/group-66-1.png"
              />
            </div>
          </div>
        </div>

        <div className="ellipse-15 absolute bottom-0 right-0 max-md:hidden" />
      </div>
    </section>
  );
};
